import(/* webpackMode: "eager" */ "D:\\xampp\\htdocs\\Vidyalaya_LMS_Website_NEXTJS\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager" */ "D:\\xampp\\htdocs\\Vidyalaya_LMS_Website_NEXTJS\\public\\images\\ic_stars.svg");
